module.exports = __webpack_public_path__ + "static/pic02-1fcc73b56ce6094508e1bf63eeca652e.jpg";